import { useCallback, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './sections/Footer';
import { DemoModal } from './components/DemoModal';
import { LandingPage } from './pages/LandingPage';
import { PricingPage } from './pages/PricingPage';

export function App(): JSX.Element {
  const [demoOpen, setDemoOpen] = useState(false);
  const [demoNotes, setDemoNotes] = useState('');

  const openDemo = useCallback((notes = '') => {
    setDemoNotes(notes);
    setDemoOpen(true);
  }, []);

  const closeDemo = useCallback(() => {
    setDemoOpen(false);
    // Clear notes on next tick so the close animation doesn't flash an empty
    // textarea. Setting back to '' is safe because the modal seeds from this
    // value only when it opens.
    setDemoNotes('');
  }, []);

  return (
    <BrowserRouter>
      <Nav onRequestDemo={() => openDemo()} />
      <Routes>
        <Route
          path="/"
          element={<LandingPage onRequestDemo={() => openDemo()} />}
        />
        <Route
          path="/pricing"
          element={<PricingPage onRequestDemo={openDemo} />}
        />
      </Routes>
      <Footer />
      <DemoModal
        open={demoOpen}
        onClose={closeDemo}
        initialNotes={demoNotes}
      />
    </BrowserRouter>
  );
}
